/**
 * Build a mapping compatible with FieldMapping.applyMapping from a register's stored schema
 * (RegisterVM.schema). Moved verbatim from ExcelUpload.vue (AVA-602 slice 1b.2). The saved schema
 * carries no Facility aliases — those are stored per source, in templates (IMP-6).
 * @param {Array<object>} schema - RegisterColumnVM entries
 * @returns {?object} { fieldMappings, fieldTypes, mandatoryFields, tagColumn, facilityColumn, identityColumn }
 */
export function buildMappingFromRegisterSchema(schema = []) {
  try {
    if (!Array.isArray(schema) || schema.length === 0) return null;

    const fieldMappings = {};
    const fieldTypes = {};
    const mandatoryFields = {};
    let tagColumn = null;
    let facilityColumn = null;
    let identityColumn = '';

    const typeToEnum = (t) => {
      const s = String(t || '').toLowerCase();
      if (s === 'number') return 2;
      if (s === 'date') return 3;
      if (s === 'boolean') return 4;
      return 1; // text
    };

    schema.forEach((col) => {
      const original = col.originalName || null;
      const fieldName = col.displayName || col.name || null;
      if (!fieldName) return;

      if (col.isIdentityColumn) {
        identityColumn = fieldName;
      }

      // Tag and Facility are special. The Tag column is restored only from the TagValue system
      // column's originalName, which the API does not persist yet (AVA-602 U8, follow-up).
      // The system column is named TagValue but displayed as "Tag", so match its name too.
      const isTagValue = col.name === 'TagValue' || fieldName === 'TagValue' || fieldName === 'tag';
      if (isTagValue && original) {
        // API uses TagValue for system column; our mapper uses 'tag' as field name
        tagColumn = original;
      }
      if (fieldName === 'FacilityName' && original) {
        facilityColumn = original;
      }

      // Use mapping only if we know which Excel column it came from
      if (original) {
        fieldMappings[original] = isTagValue ? 'tag' : fieldName;
        fieldTypes[original] = typeToEnum(col.dataType);
        if (col.isMandatory) mandatoryFields[original] = fieldName;
      }
    });

    if (Object.keys(fieldMappings).length === 0 && !tagColumn && !facilityColumn && !identityColumn) {
      return null;
    }

    return {
      fieldMappings,
      fieldTypes,
      mandatoryFields,
      tagColumn,
      facilityColumn,
      identityColumn,
    };
  } catch (e) {
    return null;
  }
}
